import HeroSection from "./lp2/HeroSection";
import HowItWorksSection from "./lp2/HowItWorksSection";
import PricingSection from "./lp2/PricingSection";
import FAQSection from "./lp2/FAQSection";
import Footer from "./lp2/Footer";
//import "./custom.css"
import Navigation from "./lp2/Navigation";
import ContactForm from "./lp2/ContactForm";
import TeamsSection from "./lp2/TeamSection";
import BlogSection from "./lp2/BlogSection.tsx";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
            <div id="hero">
              <HeroSection />
            </div>
            <div id="how-it-works">
              <HowItWorksSection />
            </div>
            {/* Die Gruendergeschichte steht dort, wo vorher die Testimonials
                waren: die glaubwuerdigste Stelle der Seite. Sie ist wahr. */}
            <div id="team">
              <TeamsSection />
            </div>
            <div id="pricing">
              <PricingSection />
            </div>
            <div id="faq">
              <FAQSection />
            </div>
            <div id="blog">
              <BlogSection />
            </div>
            <div id="contact">
              <ContactForm />
            </div>
            <Footer />

    </div>
  );
};

export default Index;
